import { useState } from "react";

export const AmountManagement = ({ currentAmount, loading, onSetAmount }) => {
    const [amount, setAmount] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        await onSetAmount(amount);
        setAmount('');
    };

    return (
        <div className="bg-slate-800 p-3 rounded-lg border border-slate-700">
            <h2 className="text-sm font-semibold text-white mb-2">
                Set Amount
            </h2>

            <form onSubmit={handleSubmit}>
                <div className="mb-1.5">
                    <label className="block text-xs font-medium text-slate-300 mb-1">
                        Amount (USD)
                    </label>
                    <input 
                        type="number"
                        step="0.01"
                        placeholder="Enter amount" 
                        value={amount} 
                        onChange={(e) => setAmount(e.target.value)}
                        required
                        className="w-full h-8 px-2 text-xs bg-slate-900 text-white border border-slate-700 rounded outline-none focus:border-green-500 focus:ring-1 focus:ring-green-500"
                    />
                </div>
                
                <button 
                    type="submit"
                    disabled={loading}
                    className={`w-full py-1.5 text-xs font-medium text-white rounded transition-all ${
                        loading 
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-green-500 hover:bg-green-600 cursor-pointer'
                    }`}
                >
                    {loading ? 'Setting...' : 'Set Amount'}
                </button>
            </form>
        </div>
    );
};
